import { StrapiRequestPayload, StrapiResponse } from '../models';

export function toStrapiRequestPayload<T>(input: T): StrapiRequestPayload<T> {
  return {
    data: input,
  };
}

export function extractStrapiData<T>(val: StrapiResponse<T>) {
  return val.data;
}
